import Card from '@material-ui/core/Card';
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import { navigate } from '@reach/router';
import React from 'react';
import { useTranslation } from '../../../hooks/useTranslation';
import ROUTES from '../../../routes';
import {
  AccountDetail,
  AccountType,
  ListProfilesResponse,
  PaymentProfile,
} from '../../../__generated__/pge-types';
import PGEButton from '../../buttons';
import { AutoPayConfigData } from '../auto-pay.types';
import AutoPayEnrolled from './AutoPayEnrolled';
import { useStyles } from './AutoPayStart.styles';
import { ApolloQueryResult } from 'apollo-client';

interface AutoPayProps {
  path?: string;
  onUpdatePaymentProfile: (config: AutoPayConfigData) => Promise<void>;
  savedProfileList?: PaymentProfile[];
  onUpdatePayDay: (config: AutoPayConfigData) => Promise<void>;
  onUpdateAutoPayConfig: (config: AutoPayConfigData) => Promise<void>;
  onCancel: () => Promise<void>;
  account: AccountDetail;
  onAutoPayConfirmSubmit: (isAmazonUpdate?: boolean) => void;
  setIneligibleValue: (value: boolean) => void;
  setShowAmazonModal: (value: boolean) => void;
  personId?: string;
  showAmazonModal?: boolean;
  refetch: () => Promise<
    [
      ApolloQueryResult<{
        listProfiles: ListProfilesResponse;
      }>,
      ApolloQueryResult<{
        getAccountDetails: Array<AccountDetail>;
      }>,
    ]
  >;
}

interface AutoPayNotEnrolledProps {
  account: AccountDetail;
}

export default function AutoPay({
  onUpdatePaymentProfile,
  savedProfileList,
  onUpdatePayDay,
  onUpdateAutoPayConfig,
  onCancel,
  account,
  onAutoPayConfirmSubmit,
  setIneligibleValue,
  setShowAmazonModal,
  personId,
  refetch,
  showAmazonModal,
}: AutoPayProps) {
  const isEnrolled = account?.autoPay?.isEnrolled;

  // if the user is enrolled, do not worry about inelibility
  if (isEnrolled) {
    return (
      <AutoPayEnrolled
        onUpdatePaymentProfile={onUpdatePaymentProfile}
        savedProfileList={savedProfileList}
        onUpdatePayDay={onUpdatePayDay}
        onUpdateAutoPayConfig={onUpdateAutoPayConfig}
        onCancel={onCancel}
        account={account}
        onAutoPayConfirmSubmit={onAutoPayConfirmSubmit}
        setIneligibleValue={setIneligibleValue}
        showAmazonModal={showAmazonModal}
        setShowAmazonModal={setShowAmazonModal}
        personId={personId}
        refetch={refetch}
      />
    );
  }

  return <AutoPayNotEnrolled account={account} />;
}

const AutoPayNotEnrolled = ({ account }: AutoPayNotEnrolledProps) => {
  const classes = useStyles();
  const { t, richT } = useTranslation();

  const handleEnrollClick = () => {
    return navigate(ROUTES.AUTO_PAY_CONFIG);
  };

  const infoResidentialNotEnrolled = richT('AUTO_PAY_NOT_ENROLLED_INFO_RES');
  const infoCommercialNotEnrolled = t('AUTO_PAY_NOT_ENROLLED_INFO_COMMERCIAL');
  const enrollButtonLabel = t('AUTO_PAYNOT_ENROLLED_ENROLL');

  return (
    <Grid container spacing={3} direction="column">
      <Grid item>
        <Card className={classes.root}>
          <CardContent>
            <Typography>
              {account?.accountType === AccountType.Res
                ? infoResidentialNotEnrolled
                : infoCommercialNotEnrolled}
            </Typography>
          </CardContent>
          <CardActions className={classes.actionArea}>
            <PGEButton onClick={handleEnrollClick}>
              {enrollButtonLabel}
            </PGEButton>
          </CardActions>
        </Card>
      </Grid>
    </Grid>
  );
};
